import BaseApi from './BaseApiWithoutAuth'
import axios from 'axios'
const CancelToken = axios.CancelToken

class Api extends BaseApi {
  /** Overide base methods **/

  /**
   * Normal http request
   *
   * @param {string} method http method
   * @param {string} url http url
   * @param {Object} data params for get or body data for post, put, patch
   * @param {Object} config axios config object. See https://github.com/mzabriskie/axios
   */
  submit (method, url, data, config = {}) {
    return super.submit(method, url, data, config)
  }

  /**
   * Submit http request with Authorization header
   *
   * @param {string} method http method
   * @param {string} url http url
   * @param {Object} data params for get or body data for post, put, patch
   * @param {Object} config axios config object. See https://github.com/mzabriskie/axios
   */
  authSubmit (method, url, data, config = {}) {
    return super.submit(method, url, data, config)
  }

  /** Api methods **/

  getData (url) {
    return this.authSubmit('get', url, {}, {
      timeout: 360 * 60 * 1000
    })
  }
  uploadS3 (request) {
    return this.authSubmit('put', request.form.url, request.form.imagedata, {
      headers: { 'Content-Type': `${request.form.extension}` },
      timeout: 360 * 60 * 1000,
      onUploadProgress: request.progressCallback,
      cancelToken: new CancelToken(request.cancelCallback)
    })
  }
  uploadTableS3 (request) {
    return this.authSubmit('put', request.form.url, request.form.tableData, {
      headers: { 'Content-Type': `${request.form.extension}` },
      timeout: 360 * 60 * 1000,
      onUploadProgress: request.progressCallback,
      cancelToken: new CancelToken(request.cancelCallback)
    })
  }
  uploadTrainingS3 (request) {
    return this.authSubmit('put', request.form.url, request.form.trainingData, {
      headers: { 'Content-Type': `${request.form.extension}` },
      timeout: 360 * 60 * 1000,
      onUploadProgress: request.progressCallback,
      cancelToken: new CancelToken(request.cancelCallback)
    })
  }
}

export default new Api()



// WEBPACK FOOTER //
// ./src/api/ApiWithoutAuth.js